import React from 'react';
import { Switch, Route, Redirect, RouteComponentProps } from 'react-router-dom';

import { CorporateAccountSearchPage, EditCorporateAccountPage } from './pages';
import { CreateCorporateAccountPage } from './pages/create-corporate-account.page';
import { InvoiceRunDetailsPage } from './pages/invoice-run-details.page';

export const CorporateAccountRoutes: React.FC<RouteComponentProps> = ({ match }) => (
  <Switch>
    <Route path={match.path} exact component={CorporateAccountSearchPage} />
    <Route path={`${match.path}/add`} component={CreateCorporateAccountPage} />
    <Route path={`${match.path}/run/:runId`} exact component={InvoiceRunDetailsPage} />
    <Route path={`${match.path}/:corporateAccountId`} component={EditCorporateAccountPage} />
    <Redirect to={match.path} />
  </Switch>
);
